exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customTableWithClr{border-collapse:separate;border-spacing:0 5px;width:100%}.customTableWithClr th:first-child{width:40px}.customTableWithClr th:last-child{width:100px}.customTableWithClr th,.customTableWithClr td{padding:8px}.customTableWithClr_tr{background-color:#eeeeee}.customTableWithClr_txt_alignLeft{text-align:left}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/customTableWithColors/CustomTableWithColors.style.scss
// module id = 1641
// module chunks = 0